export default __webpack_public_path__ + "static/notfoundMobile-d3674cb68f45595d5f3c23e9cc384da8.png";